export const isIosDevice = () => {
	const regex = /^(iPad|iPhone|iPod)/;

	if (typeof navigator === 'undefined') return false;

	return regex.test(navigator.platform);
};
